import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import RoutePath from 'App/RoutePath';

import { Link } from 'react-router-dom';
import { StyledAlert } from './BookingError.styles';

export const BookingError = () => {
  const { t } = useTranslation('book', {
    keyPrefix: 'service.form',
  });

  return (
    <StyledAlert
      className="card error"
      title={''}
      variant="error"
      size="small"
      orientation="vertical"
    >
      <Trans
        t={t}
        i18nKey="error"
        components={[<Link to={{ pathname: RoutePath.Help }} />]}
      />
    </StyledAlert>
  );
};
